var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{staticClass:"w-full text-center btn--primary",attrs:{"loading":_vm.loading,"disabled":_vm.loading || _vm.isArchived == null},nativeOn:{"click":function($event){return _vm.toggle()}}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }